import React, { useState } from 'react';
import { Modal, Tabs } from 'antd';
import { YouTubeLiveStream } from './types';
import AutoVideoSelectionComponent from './AutoVideoSelectionComponent';
import VideoManager from './VideoManager';

interface ManageVideoModalProps {
  stream: YouTubeLiveStream;
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  distributionPlatformData?: any[];
}

const ManageVideoModal: React.FC<ManageVideoModalProps> = ({
  stream,
  open,
  onClose,
  onSave,
  distributionPlatformData
}) => {
  const initialTab = stream.video_selection_mode === 'automatic' ? 'automatic' : 'manual';
  const [activeTab, setActiveTab] = useState<string>(initialTab);

  // Reset tab when stream changes
  React.useEffect(() => {
    setActiveTab(stream.video_selection_mode === 'automatic' ? 'automatic' : 'manual');
  }, [stream.id, stream.video_selection_mode]);

  const tabItems = [
    {
      key: 'automatic',
      label: 'Automatic Selection',
      children: (
        <AutoVideoSelectionComponent
          stream={stream}
          open={open}
          onClose={onClose}
          onSave={onSave}
          distributionPlatformData={distributionPlatformData}
          embedded
        />
      ),
    },
    {
      key: 'manual',
      label: 'Manual Selection',
      children: (
        <VideoManager
          stream={stream}
          open={open}
          onClose={onClose}
          onSave={onSave}
          distributionPlatformData={distributionPlatformData}
          embedded
        />
      ),
    },
  ];

  return (
    <Modal
      title={`Manage Videos - ${stream.name}`}
      open={open}
      onCancel={onClose}
      width={1000}
      footer={null}
    >
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={tabItems}
      />
    </Modal>
  );
};

export default ManageVideoModal;
